import { VStack } from '@chakra-ui/react';
import { EventSingle } from '@src/components/sco/Events/EventSingle';
import { EventsPage } from '@src/components/sco/Events/EventsLayout';
import { EventsMainPanel } from '@src/components/sco/Events/EventsLayout/EventsMainPanel.tsx';
import { useActiveContentContext } from '@src/contexts/ActiveContentContext';
import { useUniversalEffect } from '@src/hooks/useUniversalEffect';
import { useRouter } from 'next/router';
import React from 'react';
export default EventsPage(function Page() {
  const router = useRouter();
  const activeContent = useActiveContentContext();
  useUniversalEffect(() => {
    activeContent.setSiteSection('events.single');
  });
  return <EventsMainPanel>
      <VStack align={'center'} justify={'center'} marginX={'auto'} marginY={'auto'} maxWidth={'900px'} minHeight={'90vh'} padding={'1em'} width={'full'}>
        <EventSingle groupEventId={`${router.query.eventId}`} />
      </VStack>
    </EventsMainPanel>;
});